module.exports = __webpack_public_path__ + "media/images/mute-icon-ba1d9be16da03255e3c70682b216c499e6508d835ef7a7845121647c53ab1f2a.svg";